import Vue from 'vue';
import VueRouter from 'vue-router';
import user from './router/user'//用户登录、注册、完善信息、修改密码
import ceping from './router/shengyaceping'//生涯测评
import learningAbility from  './router/router'//学习力
import wayToStudy from './router/wayToStudy'// 升学途径
import wayToStudyWays from './router/wayToStudyWays'// 升学途径整改
// import upData from './router/updata.vue' //  系统维护中
import selfAssessment from './router/selfAssessment'// 认识自我

import subjectDiagnosis from './router/subjectDiagnosis' // 学科诊断
import explore from './router/explore'//外部探索
import elective from './router/elective'//新高考选科
import policyDecision from './router/policyDecision'//选择决策
import plan from './router/plan'//行动计划
import studyPlan from './router/studyPlan'//学业规划
import consultation from './router/consultation'//状态咨询
import videoCourse from './router/videoCourse'//视频课程
import consultant from  './router/consultant'//咨询师
import parent from  './router/parent'//家长角色
import strongBase from './router/strongBase' // 强基综评复试
import careerEvaluation from './router/careerEvaluation';
Vue.use(VueRouter);
const routes = [
    user,//用户登录、注册、完善信息、修改密码
    parent,//家长角色 userType:2
    //生涯档案
    {
        path:'/',
        name:'生涯档案',
        redirect:'/start',
        component:()=>import('./views/home'),
        children:[
            {
                path:'/careerArchives',
                name:'生涯档案首页',
                component:()=>import('./views/careerArchives/index'),
                meta:{requireAuth:false,roles:['student']}
            },
            {
                path:'/personalCenter',
                name:'个人中心',
                component:()=>import('./views/careerArchives/personalCenter'),
                meta:{requireAuth:false,roles:['student']}
            },
            wayToStudy, // 升学途径
            wayToStudyWays, // 升学途径整改
            selfAssessment, // 认识自我
            explore,//外部探索
            elective,//新高考选科
            policyDecision,//选择决策
            plan,//行动计划
            studyPlan,//学业规划
            consultation,//状态咨询
            videoCourse,//视频课程
            strongBase, //强基综评复试
            subjectDiagnosis, // 选科诊断
            
        ]
    },
    // {
    //     path:'/wayToStudyWays/testreport',
    //     name:'升学途径分析报告',
    //     component:()=>import('./views/wayToStudyWays/analysis_test/test_report.vue'),
    //     meta:{requireAuth:true,roles:['student']}
    // },
    {
        path:'/wayToStudyWays/studyAdviceReport',
        name:'升学建议方案',
        component:()=>import('./views/wayToStudyWays/study_advice_report/study_advice_report.vue'),
        meta:{requireAuth:true,roles:['student']}
    },
    // 自我评估生涯适应力测评报告
    {
        path:'/selfAssessment/adaptability/testreport',
        name:'生涯适应力测评报告',
        component:()=>import('./views/selfAssessment/adaptability/test_report.vue'),
        meta:{requireAuth:true,roles:['student']}
    },
    // 生涯管理系统-生涯管理-学业规划-诊断-获取报告
    {
        path:'/consultation/diagnosis/evaluationReport1',
        name:'成就目标定向测评报告',
        component:()=>import('./views/consultation/diagnosis/evaluation/evaluation_report1.vue'),
        // meta:{requireAuth:true,roles:['student']}
    },
    {
        path:'/consultation/diagnosis/evaluationReport2',
        name:'时间管理测评报告',
        component:()=>import('./views/consultation/diagnosis/evaluation/evaluation_report2.vue'),
        // meta:{requireAuth:true,roles:['student']}
    },
    {
        path:'/consultation/diagnosis/evaluationReport3',
        name:'学习动机测评报告',
        component:()=>import('./views/consultation/diagnosis/evaluation/evaluation_report3.vue'),
        // meta:{requireAuth:true,roles:['student']}
    },
    {
        path:'/consultation/diagnosis/evaluationReport4',
        name:'学习习惯测评报告',
        component:()=>import('./views/consultation/diagnosis/evaluation/evaluation_report4.vue'),
        // meta:{requireAuth:true,roles:['student']}
    },
    {
        path:'/consultation/diagnosis/evaluationReport5',
        name:'情绪管理测评报告',
        component:()=>import('./views/consultation/diagnosis/evaluation/evaluation_report5.vue'),
        // meta:{requireAuth:true,roles:['student']}
    },
    {
        path:'/consultation/diagnosis/evaluationReport6',
        name:'人际关系综合诊断测评报告',
        component:()=>import('./views/consultation/diagnosis/evaluation/evaluation_report6.vue'),
        // meta:{requireAuth:true,roles:['student']}
    },
    {
        path:'/consultation/diagnosis/evaluationReport7',
        name:'注意力测评报告',
        component:()=>import('./views/consultation/diagnosis/evaluation/evaluation_report7.vue'),
        // meta:{requireAuth:true,roles:['student']}
    },
    {
        path:'/consultation/diagnosis/evaluationReport8',
        name:'学业归因测评报告',
        component:()=>import('./views/consultation/diagnosis/evaluation/evaluation_report8.vue'),
        // meta:{requireAuth:true,roles:['student']}
    },
    {
        path:'/videoCourse/videoplay',
        name:'视频播放',
        component:()=>import('./views/videoCourse/videoplay.vue'),
        meta:{requireAuth:true,roles:['student']}
    },
    //生涯测评
    ...ceping,
    ...careerEvaluation,
    //学习力测评
    {
        path:'/learningAbility',
        component:()=>import('@/views/ceping/LearningAbility/index.vue'),
        children: learningAbility.learningAbility,
        meta:{requireAuth:true,roles:['student']}
    },
    //测评完成
    {
        path:'/cepingwancheng',
        name:'测评完成',
        component:()=>import('./views/ceping/shengyaceping/cepingwancheng'),
        meta:{requireAuth:true,roles:['student']}
    },
    //空白页
    {
        path:'/refresh',
        name:'空白页',
        component:()=>import('./views/user/refresh.vue'),
        meta:{requireAuth:true,roles:['student']}
    },
    //启动页
    {
        path:'/start',
        name:'启动页',
        component:()=>import('./views/user/start.vue'),
        meta:{requireAuth:true,roles:['student']}
    },
    {
        path:'/learningreport',
        name:'学习力报告',
        component:()=>import('./views/ceping/report/learningReport.vue'),
    },
    {
        path:'/learningreportv2',
        name:'学习力报告2',
        component:()=>import('./views/ceping/report/learningReport2.vue'),
    },
    {
        path:'/wayToStudyWays/testreport',
        name:'升学途径分析报告',
        component:()=>import('./views/wayToStudyWays/analysis_test/test_report.vue'),
        // meta:{requireAuth:true,roles:['student']}
    },
    {
        path:'/careerReport',
        name:'生涯测评报告',
        component:()=>import('./views/ceping/report/careerReport.vue'),
    },
   
    //咨询师模块
    {
        path:'/consultant',
        component:()=>import('@/views/consultant/index'),
        redirect: '/consultant/home',
        children: consultant.consultant,
        meta:{requireAuth:true,roles:['/consultant']}
    },
    {
        path:'/404',
        component:()=>import('@/views/404'),
    },

    {
        path:'*',
        component:()=>import('@/views/404'),
    },
    {
        path:'/NotFind',
        component:()=>import('@/views/interface'),
    },
    // 移动端样式
    // 专业库
    {
        path:'/zhuanyeku_mobile',
        component:()=>import('@/views/explore/zhuanyeku/zhuanyeku_mobile.vue'),
    },
    {
        path:'/zhuanyexiangqing_mobile',
        component:()=>import('@/views/explore/zhuanyeku/zhuanyexiangqing_mobile.vue'),
    },
    {
        path: '/yuanxiaoxiangqing_mobile',
        component:()=>import('@/views/explore/yuanxiaoku/yuanxiaoxiangqing_mobile.vue'),
    },
    {
        path: '/zhaoshengjianzhang_mobile',
        component:()=>import('@/views/explore/yuanxiaoku/zhaoshengjianzhang_mobile.vue'),
    },
    //T1
    // 职业库
    {
        path: '/zhiyeku_mobile',
        // name: '职业库列表',
        component:()=>import('@/views/explore/zhiyeku/zhiyeku_mobile.vue'),
    },
    {
        path: '/zhiyexiangqing_mobile',
        // name: '职业详情',
        component:()=>import('@/views/explore/zhiyeku/zhiyexiangqing_mobile.vue'),
    },
    // 高考百科
    {
        path: '/gaokaobaike_mobile',
        // name: '高考百科',
        component:()=>import('@/views/explore/gaokaobaike/gaokaobaike_mobile.vue'),
    },
    {
        path: '/baikexiangqing_mobile',
        // name: '百科详情',
        component:()=>import('@/views/explore/gaokaobaike/baikexiangqing_mobile.vue'),
    },
    // T2
    {
        path: '/putongshengxue_mobile',
        component:()=>import('@/views/wayToStudyWays/add_goschool_path/GeneralEntrance_mobile.vue'),
    },
    {
        path: '/zhongwaihezuo_mobile',
        component:()=>import('@/views/wayToStudyWays/other_goschool_path/SinoForeignCooperation_mobile.vue'),
    },
    {
        path: '/minzuyukeban_mobile',
        component:()=>import('@/views/wayToStudyWays/other_goschool_path/NationPrepClass_mobile.vue'),
    },
    {
        path: '/qiangjijihua_mobile',
        component:()=>import('@/views/wayToStudyWays/add_goschool_path/BasicPlan_mobile.vue'),
    },
    {
        path: '/zonghepingjia_mobile',
        component:()=>import('@/views/wayToStudyWays/common_school_path/ComprehensiveEvaluation_mobile.vue'),
    },
    {
        path: '/gaoxiaozhuanxiang_mobile',
        component:()=>import('@/views/wayToStudyWays/other_main_path/ThreeSpecialPlan.vue'),
    },
    {
        path: '/dingxiangsheng_mobile',
        component:()=>import('@/views/wayToStudyWays/add_goschool_path/DirectionalStudents.vue'),
    },
    {
        path: '/baosongsheng_mobile',
        component:()=>import('@/views/wayToStudyWays/other_main_path/RecommendedStudent.vue'),
    },
    {
        path: '/gaozhidanzhao_mobile',
        component:()=>import('@/views/wayToStudyWays/other_main_path/Gaozhidanzhao.vue'),
    },
    // 艺术类专业
    {
        path: '/yishulei_mobile',
        component:()=>import('@/views/wayToStudyWays/common_school_path/ArtEnrollment.vue'),
    },
    // 高水平艺术团
    {
        path: '/gaoshuiping_mobile',
        component:()=>import('@/views/wayToStudyWays/other_main_path/ArtEnsemble.vue'),
    },
    // 体育类专业
    {
        path: '/tiyulei_mobile',
        component:()=>import('@/views/wayToStudyWays/common_school_path/SportsMajor.vue'),
    },
    // 高水平运动队
    {
        path: '/gaoshuipingyd_mobile',
        component:()=>import('@/views/wayToStudyWays/other_main_path/SportsTeam.vue'),
    },
    // 体育单招
    {
        path: '/tiyudanzhao_mobile',
        component:()=>import('@/views/wayToStudyWays/other_main_path/Tiyudanzhao.vue'),
    },
    // 公费师生范
    {
        path: '/gongfeissf_mobile',
        component:()=>import('@/views/wayToStudyWays/other_main_path/PublicExpense.vue'),
    },
    // 免费医学生
    {
        path: '/mianfeiyxs_mobile',
        component:()=>import('@/views/wayToStudyWays/other_main_path/FreeMedicalStudents.vue'),
    },
    //公费农科生
    {
        path: '/gongfeinks_mobile',
        component:()=>import('@/views/wayToStudyWays/add_goschool_path/AgriculturalStudents.vue'),
    },
    // 空军招飞
    {
        path: '/kongjunzhaofei_mobile',
        component:()=>import('@/views/wayToStudyWays/military_scholl/AirForce.vue'),
    },
    // 海军招飞
    {
        path: '/haijunzhaofei_mobile',
        component:()=>import('@/views/wayToStudyWays/military_scholl/SeaForce.vue'),
    },
    // 民航招飞
    {
        path: '/minxingzhaofei_mobile',
        component:()=>import('@/views/wayToStudyWays/military_scholl/CivilAviation.vue'),
    },
    // 军事院校
    {
        path: '/junxiaosheng_mobile',
        component:()=>import('@/views/wayToStudyWays/military_scholl/MilitarySchool.vue'),
    },
    // 公安院校
    {
        path: '/gonganyuanxiao_mobile',
        component:()=>import('@/views/wayToStudyWays/military_scholl/PoliceSchool.vue'),
    },
    // 航海类专业
    {
        path: '/hanghailei_mobile',
        component:()=>import('@/views/wayToStudyWays/military_scholl/NauticalCategorySchool.vue'),
    },
    // 小语种
    {
        path: '/xiaoyuzhong_mobile',
        component:()=>import('@/views/wayToStudyWays/add_goschool_path/MinorLanguages.vue'),
    },
    // 港澳招生
    {
        path: '/gangao_mobile',
        component:()=>import('@/views/wayToStudyWays/other_goschool_path/GangaoRecruitstudents.vue'),
    },
    // haiwailiuxue
    {
        path: '/haiwailiuxue_mobile',
        component:()=>import('@/views/wayToStudyWays/other_goschool_path/StudyingAbroad.vue'),
    },
    // 升学途径测试题
    {
        path: '/entry_mobile',
        component:()=>import('@/views/wayToStudyWays/analysis_test/test_main_mobile.vue'),
    },
    // 升学途径报告
    {
        path:'/testreport_mobile',
        name:'升学途径分析报告',
        component:()=>import('@/views/wayToStudyWays/analysis_test/test_report_mobile.vue'),
    },
    // 学习状态诊断测评主界面   
    {
        path:'/evaluation_mobile',
        // name:'升学途径分析报告',
        component:()=>import('@/views/consultation/diagnosis/evaluation/evaluation_entry_mobile.vue'),
    },
    // 学习状态诊断测试题
    {
        path:'/evaluation_question_mobile',       
        component:()=>import('@/views/consultation/diagnosis/evaluation/evaluation_main_mobile.vue'),
    },
    // 学习状态诊断第七题
    {
        path:'/evaluation_question7_mobile',       
        component:()=>import('@/views/consultation/diagnosis/evaluation/evaluation_question7_mobile.vue'),
    },




]
const mode = 'hash';
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
}
const router = new VueRouter({ base: process.env.BASE_URL,routes, mode });

// const router = new VueRouter({ routes, mode });
export default router;
